import { Link } from 'react-router-dom';
import { Card, Badge } from '@bbpos/ui';

interface SetupStep {
  label: string;
  to: string;
  done: boolean;
}

interface WelcomeCardProps {
  businessName: string;
  steps: SetupStep[];
}

export function WelcomeCard({ businessName, steps }: WelcomeCardProps) {
  const completed = steps.filter((s) => s.done).length;
  const total = steps.length;
  const progressPct = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <Card className="overflow-hidden shadow-md backdrop-blur-sm bg-white/80 dark:bg-neutral-900/80 transition-shadow duration-200 hover:shadow-lg border border-brand-100 dark:border-brand-900/40">
      <div className="bg-gradient-to-r from-brand-500 via-indigo-500 to-violet-500 px-6 py-4">
        <div className="flex items-start justify-between">
          <div>
            <h2 className="text-lg font-bold text-white">
              Welcome to Orio360, {businessName}!
            </h2>
            <p className="text-sm text-brand-100 mt-0.5">
              Complete these steps to start billing
            </p>
          </div>
          <Badge variant="info">{completed}/{total}</Badge>
        </div>
      </div>

      <div className="px-6 pt-4 pb-2">
      {/* Progress bar */}
      <div className="w-full h-2 bg-neutral-200 dark:bg-neutral-700 rounded-full mb-4">
        <div
          className="h-2 bg-gradient-to-r from-brand-500 to-indigo-500 rounded-full transition-all duration-500"
          style={{ width: `${progressPct}%` }}
        />
      </div>

      <ul className="space-y-2">
        {steps.map((step) => (
          <li key={step.label}>
            <Link
              to={step.to}
              className="flex items-center gap-3 rounded-lg px-3 py-2 hover:bg-neutral-50 dark:hover:bg-neutral-800 transition-colors"
            >
              <span
                className={`flex items-center justify-center h-5 w-5 rounded-full shrink-0 ${
                  step.done
                    ? 'bg-success-100 text-success-700 dark:bg-success-900/30 dark:text-success-400'
                    : 'bg-neutral-100 text-neutral-400 dark:bg-neutral-800 dark:text-neutral-500'
                }`}
              >
                {step.done ? (
                  <svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                ) : (
                  <span className="h-2 w-2 rounded-full bg-neutral-300 dark:bg-neutral-600" />
                )}
              </span>
              <span
                className={`text-sm ${
                  step.done
                    ? 'text-neutral-400 line-through'
                    : 'text-neutral-700 dark:text-neutral-200 font-medium'
                }`}
              >
                {step.label}
              </span>
            </Link>
          </li>
        ))}
      </ul>
      </div>
    </Card>
  );
}
